import React, { useState } from "react"
import { navigate } from "vike/client/router"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import Modal from "aldoo-ra/Modal"
import { showPromptDialog } from "aldoo-ra/PromptDialog"
import { GetCMSContent } from "aldoo-ra/CMS/api"
import DataTable from "aldoo-ra/DataTable"
import { twMerge } from "tailwind-merge"

const ChatResponsePresets = ({ onClose, onSelect }) => {
  const [refreshKey, setRefreshKey] = useState(0)
  const [selectedPresets, setSelectedPresets] = useState([])

  // Handle the manage button click
  const handleManage = () => {
    showPromptDialog({
      title: "Manage Agent Replies",
      message: "You will now go to Site Contents to manage your agent replies",
      confirmText: "Continue",
      onConfirm: () => {
        navigate("/admin/cms/contents?type=CSAgentReply")
      },
    })
  }

  // Toggle preset selection
  const togglePresetSelection = (preset) => {
    setSelectedPresets((prev) =>
      prev.find((p) => p._id === preset._id)
        ? prev.filter((p) => p._id !== preset._id)
        : [...prev, preset]
    )
  }

  // Handle using selected presets
  const handleUse = () => {
    if (selectedPresets.length > 0) {
      // Join selected preset messages and pass to parent
      const combinedText = selectedPresets
        .map((p) => p.content?.message || "")
        .join("\n")
      onSelect(combinedText)
    }
  }

  // Define columns for DataTable
  const columns = [
    {
      id: "message",
      title: "",
      render: (value, item) => {
        const isSelected = selectedPresets.find((p) => p._id === item._id)
        return (
          <div
            key={item._id}
            className={twMerge(
              "py-3 px-4 cursor-pointer text-left border-b border-admin_bordered w-full",
              isSelected
                ? "bg-admin_primary_lt/60"
                : "hover:bg-admin_primary_lt/10"
            )}
            style={{ marginBottom: "-1px" }}
            onClick={() => togglePresetSelection(item)}
          >
            <Typography
              variant="admin_body"
              className={isSelected ? "text-admin_text_inv" : "text-admin_text"}
            >
              {item.content?.message || "No message content"}
            </Typography>
          </div>
        )
      },
    },
  ]

  // Request fields for filtering
  const getRequestFields = () => {
    return {
      match: {
        "content.type": "CSAgentReply",
        deleted: { $ne: true },
      },
    }
  }

  // Custom header controls
  const headerControls = (
    <div className="flex items-center justify-end">
      <Button variant="admin_secondary" onClick={handleManage}>
        Manage
      </Button>
    </div>
  )

  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      closeOnEscape
      title="Agent Reply Presets"
      variant="admin_centered"
      zIndex={50}
    >
      <div className="flex-1 overflow-y-auto mb-4">
        <DataTable
          variant="admin_compact"
          apiMethod={GetCMSContent}
          preferredHeight="50vh"
          headerControls={headerControls}
          searchField="content.message"
          requestFields={getRequestFields()}
          sort={{ createdAt: -1 }}
          localUserPreferencesKey="admin.customerSupport.chatPresets"
          renders={columns}
          refreshKey={refreshKey}
          itemHeight="auto"
          tableClassName="w-full"
          rowClassName="p-0"
          rowStyle={{ margin: 0, padding: 0 }}
          noData={
            <div
              className="flex items-center justify-center h-full"
              style={{ minHeight: "50vh" }}
            >
              <Typography variant="admin_body" className="text-center">
                No preset responses found
              </Typography>
            </div>
          }
          styleOverrides={{
            searchInput: "w-full mr-8",
          }}
        />
      </div>

      {/* Footer */}
      <div className="flex justify-between items-center mt-4">
        <Typography
          variant="admin_body"
          className="text-admin_text_secondary px-4 py-1 rounded-sm bg-admin_primary/5"
        >
          {selectedPresets.length} selected
        </Typography>

        {selectedPresets.length > 0 && (
          <Button
            variant="admin_primary"
            className="min-w-36 w-1/3"
            onClick={handleUse}
          >
            Use
          </Button>
        )}
      </div>
    </Modal>
  )
}

export default ChatResponsePresets
